import React from "react";
import { flexRender } from "@tanstack/react-table";
import {
  tableDateColumns,
  tableDateFormat,
  tableBooleanColumns,
  tableBooleanFormat,
  tableTitleCaseColumns,
  tableTitleCaseFormat,
} from "./table-types";

interface TableFormatRowProps {
  row: any;
}

export const TableFormatRow: React.FC<TableFormatRowProps> = ({ row }) => {
  return (
    <>
      {row.getVisibleCells().map((cell: any) => {
        const columnId = cell.column.id;
        const cellValue = cell.getValue();
        let columnValue;
        if (tableDateColumns.includes(columnId) && cellValue) {
          columnValue = tableDateFormat(cellValue);
        } else if (tableTitleCaseColumns.includes(columnId) && cellValue) {
          columnValue = tableTitleCaseFormat(cellValue);
        } else if (
          tableBooleanColumns.includes(columnId) &&
          typeof cellValue === "boolean"
        ) {
          columnValue = tableBooleanFormat(cellValue);
        } else {
          columnValue = flexRender(
            cell.column.columnDef.cell,
            cell.getContext()
          );
        }
        return <td key={cell.id}>{columnValue}</td>;
      })}
    </>
  );
};
